<template>
  <transition name="slide">
    <div v-show="showList" class="floating-chat-rooms">
      <div class="card">
        <div class="card-header">
          <span class="card-title">
            <i class="fas fa-comment-dots"></i> Room Groups
          </span>
          <div class="card-header-actions">
            <button
              class="card-header-action btn btn-link btn-sm dropdown-toggle"
              id="dropdownAddRoom"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Add
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownAddRoom">
              <a href="#" class="dropdown-item add-room-btn" @click.prevent="showChatForm = true">
                <i class="fas fa-users"></i> Room
              </a>
            </div>
            <a href="#" class="card-header-action close-chat-rooms" @click.prevent="showList = false">
              <i class="far fa-times-circle"></i>
            </a>
          </div>
        </div>

        <div class="card-body overflow-auto">
          <div v-show="showChatForm" class="add-room border-bottom pt-4 px-4 pb-2">
            <h5>Create Chat Room</h5>
            <form @submit.prevent="createChatConversation" id="form-add-room-float">
              <div class="form-group">
                <label>Title</label>
                <input type="text" v-model="title" name="title" class="form-control" required>
              </div>
              <div class="form-group">
                <label>Select Users</label>
                <v-select v-model="selectedUsers" class="select-users" multiple label="name" :options="userOptions" />
              </div>
              <div class="form-group text-center">
                <button type="submit" class="btn btn-sm btn-primary" :disabled="isCreatingRoom">
                  <span v-if="isCreatingRoom">Creating room...</span>
                  <span v-else>
                    <i class="far fa-comments"></i> Start Chat
                  </span>
                </button>
                <button type="button" class="btn btn-sm btn-danger" @click="showChatForm = false">
                  Cancel
                </button>
              </div>
            </form>
          </div>

          <template v-if="!isLoading && chatGroups.length > 0">
            <div v-for="room in chatGroups" :key="room.id" class="conversation-list-item">
              <a href="#" class="list-group-item list-group-item-action" @click.prevent="openChatGroupConversation(room.id)">
                <div class="media">
                  <div class="media-body ml-2">
                    <div class="d-flex align-items-center justify-content-between mb-1">
                      <h6 class="mb-0">{{ room.title }}</h6>
                    </div>
                    <p class="font-italic mb-0 text-small">
                      <span>{{ room.users }}</span>
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </template>

          <template v-if="isLoading || chatGroups.length === 0">
            <p class="text-center mt-4">
              {{ isLoading ? 'Loading your chat groups..' : 'No chat groups found.' }}
            </p>
          </template>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import vSelect from "vue-select";
import { mapMutations } from "vuex";
import { eventBus } from "../../utils/helpers";
import { createChatRoom, getBranches, getFloatingChatRooms, getGroupChatRooms, isFloating } from "../../services/api/uni-chat";

import "vue-select/dist/vue-select.css";

export default {
  name: "ChatConversationList",
  components: {
    'v-select': vSelect
  },
  data() {
    return {
      isLoading: false,
      isCreatingRoom: false,
      showChatForm: false,
      showList: false,
      branches: [],
      chatGroups: [],
      title: "",
      selectedUsers: []
    }
  },
  mounted() {
    eventBus.$on('open-chat-group-list', (show) => {
      this.showList = show;

      this.getAllBranches();
      this.getChatConversations();
    });
    eventBus.$on('open-chat-group', (room_id) => {
      this.openChatGroupConversation(room_id);
    });
  },
  computed: {
    userOptions() {
      const options = [];
      this.branches.forEach(branch => {
        branch.users.forEach(user => {
          options.push({
            id: user.id,
            name: user.name
          });
        });
      });
      return options;
    }
  },
  methods: {
    ...mapMutations("chat", ["SET_CHAT_ROOMS", "SET_SHOW_CHAT_CONTAINER"]),

    async createChatConversation() {
      try {
        this.isCreatingRoom = true;

        const userIds = this.selectedUsers.map(user => user.id);
        const payload = {
          type: 'group',
          title: this.title,
          users: userIds
        };

        const response = await createChatRoom(payload);

        if (response.status === 200) {
          new Noty({
            type: 'success',
            text: 'Chat conversation created successfully!',
            timeout: 3000
          }).show();

          this.title = '';
          this.selectedUsers = [];

          await this.getAllBranches();
          await this.getChatConversations();
        }
      } catch (error) {
        console.error("Error creating chat room:", error);
      } finally {
        this.isCreatingRoom = false;
      }
    },
    async getAllBranches() {
      try {
        this.isLoading = true;

        const response = await getBranches();
        this.branches = response.data.data;
      } catch (error) {
        console.error('Error fetching branches:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async getChatConversations() {
      try {
        this.isLoading = true;

        const response = await getGroupChatRooms();
        this.chatGroups = response.data.data;
      } catch (error) {
        console.error('Error fetching chat groups:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async openChatGroupConversation(room_id) {
      try {
        const response = await isFloating({ room_id: room_id, is_floating: true });

        if (response.status === 200) {
          const rooms = await getFloatingChatRooms('1');

          this.SET_SHOW_CHAT_CONTAINER(true);
          this.SET_CHAT_ROOMS(rooms.data);

          this.showList = false;
        }
      } catch (error) {
        console.error('Error opening chat conversation:', error);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-enter-active, .slide-leave-active {
  transform: translateX(0%);
  transition: all 0.5s;
}
.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}

.floating-chat-rooms {
  border-radius: 10px 0 0 10px;
  .card {
    border-radius: 10px 0 0 10px;
    .card-header {
      border-radius: 10px 0 0;
    }
    .card-body {
      .conversation-list-item {
        &:last-child {
          .list-group-item {
            border-bottom-left-radius: 10px;
            border-bottom: none;
          }
        }
        .list-group-item {
          border-radius: 0px;
          border: none;
          border-bottom: 1px solid rgba(0, 40, 100, 0.12);
        }
      }
    }
  }
}

// Select options
::v-deep .select-users {
  .vs__search {
    margin: 4px 4px 6px;
  }
  .vs__dropdown-toggle {
    padding: 0;
    .vs__selected {
      margin: 4px 2px 5px;
    }
  }
  .vs__dropdown-menu {
    padding: 0 0 5px;
    .vs__dropdown-option {
      padding: 6px 9px;
      border-top: 1px solid lightgrey;

      &:hover, &.vs__dropdown-option--highlight {
        background: #009f91;
      }
    }
  }
}
</style>